import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ui_mail",
  "use": "ui_mail-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"ui_mail\">\n  <path d=\"M20.72,3.12H3.28A3.28,3.28,0,0,0,0,6.4V17.61a3.28,3.28,0,0,0,3.28,3.28H20.72A3.28,3.28,0,0,0,24,17.61V6.4A3.28,3.28,0,0,0,20.72,3.12Zm-7.45,9.09a1.89,1.89,0,0,1-2.55,0L2.82,4.75a1.68,1.68,0,0,1,.45-.06H20.72a1.68,1.68,0,0,1,.45.06Zm9.16-5.82V17.72a1.71,1.71,0,0,1-1.7,1.59H3.28A1.71,1.71,0,0,1,1.57,17.6V6.4a1.69,1.69,0,0,1,.1-.58l8,7.53a3.48,3.48,0,0,0,4.7,0l8-7.54A1.7,1.7,0,0,1,22.43,6.39Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol